export default "__VITE_PUBLIC_ASSET__bbe6ee7b__"